export const PUBLIC_URL = process.env.PUBLIC_URL;
const API_URL = process.env.API_URL;

export const API_ROUTE_PATH = {
  setupSession: () => `${API_URL}/setup-session`,
  getEntries: () => `${API_URL}/entries`,
  getEntry: (id: string) => `${API_URL}/entries/${id}`,
} as const;
